// REACT
import React, { Component } from 'react';

// REDUX
import { connect } from 'react-redux';
import * as actions from 'actions';

// Components
import { FluidSection } from 'components/FluidSection/index';
import { Content } from 'components/Content/index';
import { StyledMediaQ } from 'components/StyledMediaQ';
import SpaceAround from 'components/Positioners/SpaceAround';
import FlexEnd from 'components/Positioners/FlexEnd';
import SecondaryText from 'components/TextModifiers/SecondaryText';
import H3 from 'components/Primatives/H3';
import PText from 'components/Primatives/PText';
import InfoField from 'components/InfoField';

// Material UI
import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';
import ArrowLeft from 'material-ui/svg-icons/hardware/keyboard-arrow-left';

// UTILS
import { generateToken } from 'utils/database/database-utils';
import {
    getTodaysDate,
    getUserTimezone,
    convertDateTimeToUserTimezone,
} from 'utils/timezoneUtils';
import { constants } from 'constants/index';
import { isStaging } from '../../firebase/firebase';

// Vendor Libraries
import { NavLink, withRouter } from 'react-router-dom';
import moment from 'moment-timezone';
import styled from 'styled-components';

class Booking extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    shouldDisableRebook = booking => {
        const startMoment = moment.tz(
            `${booking.startDate} ${booking.startTime}`,
            'YYYY-MM-DD HH:mm:ss',
            booking.userTimezone,
        );
        const currentTz = moment.tz.guess();
        const localStart = startMoment.clone().tz(currentTz);
        const localStartTimestamp = localStart.format('x');
        const localStartMinus24 = localStartTimestamp - 86400000;
        const now = moment().format('x');

        if (now > localStartMinus24) {
            return true;
        }
        return false;
    };

    render() {
        const {
            dateTime,
            status,
            isLoading,
            isConfirmed,
            booking: bookingData,
            userId,
            isToday,
            getConsultLink,
            i: index,
            userData,
        } = this.props;
        const booking = {
            ...bookingData,
            isLoading,
            isConfirmed,
            isToday,
            status,
            dateTime,
        };

        const isProvider = userData && userData.provider;
        // console.log('BOOKING STATUS', booking.status, booking.isLoading, booking.isConfirmed );
        // console.log('BOOKING reason',  booking.reason );

        const OuterContainer = styled.div`
            /*
                display: flex
                flex-flow: column nowrap;
            */
            margin-bottom: 30px;
            background-color: white;
            border-bottom: rgba(0, 0, 0, 0.14) 1px solid;
            padding: 20px 30px 30px 30px;
            box-shadow: ${constants.layout.shadows.dropShadow};
            border-radius: 15px;
            max-width: 600px;
            /* min-width: 85%; */
            align-self: center;
            margin-top: 30px;

            @media only screen and (max-width: ${constants.layout.breakpoint
                    .break1}px) {
                max-width: 75%;
                min-width: 75%;
            }
        `;

        const InnerContainer = styled.div`
            display: flex;
            flex-flow: column nowrap;
            align-items: center;
            padding-top: 20px;
        `;
        console.log('isStaging', isStaging);
        return (
            <OuterContainer id="Booking-OuterContainer" key={index}>
                {booking.isConfirmed && (
                    <InnerContainer id="Booking-InnerContainer">
                        {booking.isConfirmed && (
                            <React.Fragment>
                                <InfoField icon="calendar-alt" iconStyle="far">
                                    <PText style={{ marginRight: 15 }}>
                                        Date:
                                    </PText>
                                    <PText altColor style={{ flex: 1 }}>
                                        {booking.dateTime.format(
                                            'MMMM DD[,] YYYY',
                                        )}{' '}
                                        ({moment().to(booking.dateTime)})
                                    </PText>
                                </InfoField>
                                <InfoField icon="clock" iconStyle="far">
                                    <PText style={{ marginRight: 15 }}>
                                        Time:
                                    </PText>
                                    <PText altColor style={{ flex: 1 }}>
                                        {booking.dateTime.format('h[:]mm a')}
                                    </PText>
                                </InfoField>
                                {booking.reason && userData.provider && (
                                    <InfoField
                                        icon="comment-alt"
                                        iconStyle="far"
                                    >
                                        <PText style={{ marginRight: 15 }}>
                                            Reason:
                                        </PText>
                                        <PText altColor style={{ flex: 1 }}>
                                            {booking.reason}
                                        </PText>
                                    </InfoField>
                                )}
                            </React.Fragment>
                        )}
                        <div
                            style={{
                                paddingTop: 30,
                                width: '100%',
                                maxWidth: 300,
                            }}
                        >
                            {booking &&
                                booking.status !== 'cancelled' &&
                                booking.status !== 'failed' && (
                                    <NavLink to={getConsultLink(booking)}>
                                        <RaisedButton
                                            primary={true}
                                            disabled={
                                                !booking.isToday && !isStaging
                                            }
                                            style={{
                                                cursor:
                                                    !booking.isToday &&
                                                    !isStaging
                                                        ? 'not-allowed'
                                                        : 'auto',
                                            }}
                                            fullWidth
                                            buttonStyle={{
                                                ...styles.buttonStyle,
                                                backgroundColor:
                                                    !booking.isToday &&
                                                    !isStaging
                                                        ? '#C6CACC'
                                                        : '#4AC4D1',
                                            }}
                                        >
                                            START CONSULT
                                        </RaisedButton>
                                    </NavLink>
                                )}

                            {booking &&
                                booking.status !== 'cancelled' &&
                                !this.shouldDisableRebook(booking) &&
                                !isProvider && (
                                    <NavLink
                                        to={`/calendar/rebook/${booking.key}/${
                                            booking.serviceKey
                                        }/`}
                                    >
                                        <FlatButton
                                            primary={true}
                                            style={{
                                                cursor: this.shouldDisableRebook(
                                                    booking,
                                                )
                                                    ? 'not-allowed'
                                                    : 'pointer',
                                                fontSize:
                                                    constants.text
                                                        .baseFontStyles
                                                        .fontSize,
                                            }}
                                            disabled={this.shouldDisableRebook(
                                                booking,
                                            )}
                                            fullWidth
                                            buttonStyle={{
                                                ...styles.buttonStyle,
                                                backgroundColor: !booking.isToday
                                                    ? '#C6CACC'
                                                    : '#4AC4D1',
                                            }}
                                        >
                                            REBOOK CONSULT
                                        </FlatButton>
                                    </NavLink>
                                )}
                        </div>
                    </InnerContainer>
                )}

                {!booking.isConfirmed &&
                    !booking.isLoading &&
                    !isProvider && (
                        <StyledMediaQ
                            defaultStyles={`
                                display: flex;
                                flex-flow: column nowrap;
                                width: 100%;
                                align-items: center;
                                justify-content: space-around;
                            `}
                        >
                            <p
                                style={{
                                    color: 'red',
                                    fontSize:
                                        constants.text.baseFontStyles.fontSize,
                                }}
                            >
                                Booking Failed
                            </p>
                            <div style={styles.rebookCard}>
                                <NavLink
                                    to={`/calendar/rebook/${booking.key}/${
                                        booking.serviceKey
                                    }/`}
                                >
                                    <RaisedButton
                                        secondary={true}
                                        style={{ cursor: 'pointer' }}
                                        fullWidth
                                        buttonStyle={{
                                            ...styles.buttonStyle,
                                            backgroundColor: '#4AC4D1',
                                        }}
                                    >
                                        REBOOK CONSULT
                                    </RaisedButton>
                                </NavLink>
                            </div>
                        </StyledMediaQ>
                    )}

                    {!booking.isConfirmed &&
                    !booking.isLoading &&
                    isProvider && (
                        <StyledMediaQ
                            defaultStyles={`
                                display: flex;
                                flex-flow: column nowrap;
                                width: 100%;
                                align-items: center;
                                justify-content: space-around;
                            `}
                        >
                            <p
                                style={{
                                    color: 'red',
                                    fontSize:
                                        constants.text.baseFontStyles.fontSize,
                                }}
                            >
                                Booking Failed
                            </p>
                            <div style={styles.rebookCard}>
                                Your client can rebook using the REBOOK CONSULT button on the consult information card in their list of upcoming consultations. {/* TODO: WRITE FAQ ON HOW TO GET CONSUMERS TO REBOOK OR BETTER YET COMPLETE BOOKING CANCELLATION FEATURE */}
                            </div>
                        </StyledMediaQ>
                    )}
            </OuterContainer>
        );
    }
}

export default withRouter(
    connect(
        null,
        actions,
    )(Booking),
);

const styles = {
    css: ``,
    date: {
        display: 'flex',
        justifyContent: 'flex-start',
        minWidth: 105,
        fontSize: constants.text.baseFontStyles.fontSize,
    },
    secondaryText: {
        display: 'flex',
        justifyContent: 'flex-end',
        // minWidth: 80,
        paddingRight: 20,
    },
    dateContainer: {
        display: 'flex',
        justifyContent: 'flex-start',
        flexFlow: 'row nowrap',
        alignItems: 'baseline',
    },
    buttonStyle: {
        width: '100%',
        color: 'rgba(255, 255, 255, 0.78)',
        letterSpacing: '0.03em',
        fontSize: constants.text.baseFontStyles.fontSize,
    },
    rebookCard: {
        paddingTop: 30,
        width: '100%',
        maxWidth: 300,
        fontSize: constants.text.baseFontStyles.fontSize,
    },
};



// WEBPACK FOOTER //
// ./src/js/components/Booking/Booking.jsx